<template>

    <div
        @click="$emit('click', data)"
        class="entry has-text-centered is-size-7">

    <template v-if="!$_.get(data, 'subject.details.linguistic')">

        <p>
            {{ $_.get(data, "subject.title") }}
        </p>

        <div v-if="data.subject.type == 'main'">

            <p v-if="data.class_type == 'lecture'">
                Лекция
            </p>
            <p v-else-if="data.class_type == 'seminar'">
                Семинар
            </p>
            <p v-else-if="data.class_type == 'practice'">
                Практическое
            </p>

        </div>

    </template>

        <div class="tags" v-if="data.parity != 'both'">

            <span
                class="tag is-small is-even"
                v-if="data.parity == 'even'">
                Чётная неделя
            </span>
            <span
                class="tag is-small is-odd"
                v-else-if="data.parity == 'odd'">
                Нечётная неделя
            </span>

        </div>
        
        <p v-if='$_.has(data, "teacher")'>
            {{ $_.get(data, "teacher.short_name") }}
        </p>
        
        <p v-if='$_.has(data, "extra_teacher")'>
            <i>{{ $_.get(data, "extra_teacher.short_name") }}</i>
        </p>
        
        <p v-if='$_.has(data, "classroom")'>
            {{ $_.get(data, "classroom.title") }}
        </p>

        <p v-if='$_.has(data, "first_week") && !data.first_week'>
            <span>С {{ data.begin_at | moment('DD.MM') }}</span>
        </p>

    </div>

</template>

<script>
export default Vue.extend({
  props: {
    data: {
      type: [Object],
      required: true
    }
  },
  methods: {
    ofType(subject, type) {
      switch (type) {
        case "main": {
          return subject.type == "main";
        }
        case "linguistic": {
          if (subject.type == "main") {
            return subject.details.linguistic != null;
          }
        }
      }

      return false;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ScheduleEntry.vue